import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdContent } from '@jira/navigation-apps__constants/src/SidebarIdContent.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { devOpsProviderResource } from '@jira/router-resources__devops-provider/src/devOpsProviderResource.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@jira/software__devops-fedramp-utils/src/isDevopsFeatureDisabledInFedRamp.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { componentWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { softwareReportsDeploymentFrequencyClassicBoardRoute } from '@jira/router-routes__classic-projects-routes/src/softwareReportsDeploymentFrequencyClassicBoardRoute.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import { fg } from '@atlassian/jira-feature-gating';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import {
	DeploymentFrequencyReportClassic,
	LazyDeploymentFrequencyReport,
} from './ui/software/reports/deployment-frequency/index-old.tsx';
import { getReportsCommonResource } from './common/ui/resources/reports/index.tsx';
import {
	deploymentFrequencyReportPageEntrypoint,
	GSNDeploymentFrequencyReportPageEntrypoint,
} from './ui/software/reports/deployment-frequency/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareReportsDeploymentFrequencyClassicBoardRouteEntry: Route = createEntry(
	softwareReportsDeploymentFrequencyClassicBoardRoute,
	() => ({
		group: 'classic-software',
		// eslint-disable-next-line no-restricted-syntax
		component: componentWithCondition(
			() =>
				fg('aem_rr_classic_projects')
					? !isFeatureEnabled('jira', 'jira-software-reports-deployment-frequency')
					: isDevopsFeatureDisabledInFedRamp(),
			ErrorPagesNotFound,
			DeploymentFrequencyReportClassic,
		),
		entryPoint: () => {
			if (
				fg('aem_rr_classic_projects')
					? !isFeatureEnabled('jira', 'jira-software-reports-deployment-frequency')
					: isFedRamp()
			) {
				return notFoundPageEntrypoint;
			}
			if (fg('navx-global-side-nav')) {
				return GSNDeploymentFrequencyReportPageEntrypoint;
			}
			return deploymentFrequencyReportPageEntrypoint;
		},
		layout: genericProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdContent,
		},
		resources: [
			...getNavigationResources({ isUsingSidebarEntrypoint: true }),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getReportsCommonResource(),
			devOpsProviderResource,
		],
		afterPaint: [LazyDeploymentFrequencyReport],
		forPaint: [LazyAtlassianNavigation, LazyDeploymentFrequencyReport],
		meta: {
			reporting: {
				id: 'software-reports-deployment-frequency-classic',
				packageName: camelCase('software-reports-deployment-frequency-classic'),
				teamName: 'fusion-solaris',
			},
		},
		supportsPreviewPanel: true,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
